export class User {
  id: number
  branch: number
  name: string
  lastname: string
  username: string
  password: string
  role: Role
  address: string
  zip: number
  city: string
  province: string
  phone: number
  email: string
  profile: ClientProfile
  client: string

  constructor(props: User) {
    Object.assign(this, props)
  }

  get isProfessional() {
    return this.profile === ClientProfile.Professional
  }

  get isRetail() {
    return this.profile === ClientProfile.Retail
  }

  get isAdministrator() {
    return this.role === Role.Administrator
  }

  get isSupervisor() {
    return this.role === Role.Supervisor
  }

  get isSeller() {
    return this.role === Role.Seller
  }
}

export const Role = {
  Administrator: 'administrator',
  Supervisor: 'supervisor',
  Seller: 'seller'
}

export type Role = string

export const ClientProfile = {
  Hospitality: 'hospitality',
  Professional: 'professional',
  Retail: 'retail'
}

export type ClientProfile = string



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/Users/Model.ts